import { dew as _parseAccountDew } from "../../accounts/utils/parseAccount.js";
import { dew as _accountDew } from "../../errors/account.js";
import { dew as _assertCurrentChainDew } from "../../utils/chain/assertCurrentChain.js";
import { dew as _transactionRequestDew } from "../../utils/formatters/transactionRequest.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _indexDew } from "../../utils/index.js";
import { dew as _assertRequestDew } from "../../utils/transaction/assertRequest.js";
import { dew as _getChainIdDew } from "../public/getChainId.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.signTransaction = void 0;
  const parseAccount_js_1 = _parseAccountDew();
  const account_js_1 = _accountDew();
  const assertCurrentChain_js_1 = _assertCurrentChainDew();
  const transactionRequest_js_1 = _transactionRequestDew();
  const getAction_js_1 = _getActionDew();
  const index_js_1 = _indexDew();
  const assertRequest_js_1 = _assertRequestDew();
  const getChainId_js_1 = _getChainIdDew();
  async function signTransaction(client, args) {
    const {
      account: account_ = client.account,
      chain = client.chain,
      ...transaction
    } = args;
    if (!account_) throw new account_js_1.AccountNotFoundError({
      docsPath: "/docs/actions/wallet/signTransaction"
    });
    const account = (0, parseAccount_js_1.parseAccount)(account_);
    (0, assertRequest_js_1.assertRequest)({
      account,
      ...args
    });
    const chainId = await (0, getAction_js_1.getAction)(client, getChainId_js_1.getChainId, "getChainId")({});
    if (chain !== null) (0, assertCurrentChain_js_1.assertCurrentChain)({
      currentChainId: chainId,
      chain
    });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || transactionRequest_js_1.formatTransactionRequest;
    if (account.type === "local") return account.signTransaction({
      ...transaction,
      chainId
    }, {
      serializer: client.chain?.serializers?.transaction
    });
    return await client.request({
      method: "eth_signTransaction",
      params: [{
        ...format(transaction),
        chainId: (0, index_js_1.numberToHex)(chainId),
        from: account.address
      }]
    });
  }
  exports.signTransaction = signTransaction;
  //# sourceMappingURL=signTransaction.js.map
  return exports;
}